import { render, staticRenderFns } from "./EditTabContact.vue?vue&type=template&id=d81acdfe"
import script from "./EditTabContact.vue?vue&type=script&lang=js"
export * from "./EditTabContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports